import { render, staticRenderFns } from "./admindialog.vue?vue&type=template&id=5341f70e&scoped=true"
import script from "./admindialog.vue?vue&type=script&lang=js"
export * from "./admindialog.vue?vue&type=script&lang=js"
import style0 from "./admindialog.vue?vue&type=style&index=0&id=5341f70e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341f70e",
  null
  
)

export default component.exports